export const CONVERSATION_STATUS_FILTERS = [
    'all',
    'important',
    'unread',
    'archived',
    'done',
] as const;

/**
 * Mutually exclusive inbox status filters for the chat inbox list.
 */
export type ConversationStatusFilter =
    (typeof CONVERSATION_STATUS_FILTERS)[number];

/**
 * Maps a status filter to the GraphQL `getConversations` boolean arguments.
 */
export function statusFilterToGraphQLArgs(
    statusFilter: ConversationStatusFilter,
): {
    IsImportant: boolean;
    IsArchived: boolean;
    IsDone: boolean;
    IsUnread: boolean;
} {
    return {
        IsImportant: statusFilter === 'important',
        IsArchived: statusFilter === 'archived',
        IsDone: statusFilter === 'done',
        IsUnread: statusFilter === 'unread',
    };
}

/**
 * Whether a conversation should appear in the inbox list for the active filter.
 * Mirrors backend list rules for optimistic client-side trimming after mutations.
 */
export function conversationMatchesStatusFilter(
    conversation: {
        IsImportant: boolean;
        IsArchived: boolean;
        IsDone: boolean;
        UnreadMessageCount: number;
    },
    statusFilter: ConversationStatusFilter,
): boolean {
    if (statusFilter === 'all') {
        return !conversation.IsArchived && !conversation.IsDone;
    }
    switch (statusFilter) {
        case 'important':
            return conversation.IsImportant;
        case 'archived':
            return conversation.IsArchived;
        case 'done':
            return conversation.IsDone;
        case 'unread':
            return conversation.UnreadMessageCount > 0;
        default:
            return true;
    }
}
